import { render } from "./MedGelView.vue?vue&type=template&id=0e590df7&scoped=true"
import script from "./MedGelView.vue?vue&type=script&lang=js"
export * from "./MedGelView.vue?vue&type=script&lang=js"

import "./MedGelView.vue?vue&type=style&index=0&id=0e590df7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e590df7"]])

export default __exports__